module.exports = __webpack_public_path__ + "img/yyzzsl_img.afa216d3.png";